import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import Grid from "core/Grid";
import ImagesContainer from "./ImagesContainer";
import EditModalContentRightCol from "./EditModalContentRightCol";

import {
    EditModal,
    LeftColGridItem,
    RightColGridItem,
    SectionContainer
} from "./styles";

import { useSelect } from "../hooks/useSelect";
import { useEditPhotoUpload } from "./EditPhotoUploadContext";
import { AddTagsProvider } from "core/AddTags/__hooks__/useAddTags";

const Edit = ({ uploadsInDropzoneIds }) => {
    const { quantityChecked, clearAllChecked, checkItems } = useSelect();
    const {
        closeEditModal,
        editModalIsOpen,
        uploadIds: currentlyEditingUploadIds,
        uploads: uploadsCurrentlyEditing
    } = useEditPhotoUpload();

    const rightColRef = useCallback(element => {
        if (element !== null) {
            setRightColWidth(element.getBoundingClientRect().width);
        }
    }, []);

    // use useEffect to run rightcolref again if resized & unmount the rightcolref to prevent mem leak:
    useEffect(() => {
        window.addEventListener("resize", () => {
            rightColRef;
        });

        return () => {
            window.removeEventListener("resize", () => {
                rightColRef;
            });
        };
    }, [hasRightColWidth]);

    const [hasRightColWidth, setRightColWidth] = useState(0);

    // modal is carousel if ONLY 1 photo is checked/selected, or if NO photos are checked/selected AND there are accepted images:
    const isModalCarousel = quantityChecked === 1;

    const modalType = isModalCarousel ? "carousel" : "text";

    const modalHeading = isModalCarousel
        ? "Editing selected photo"
        : quantityChecked === 1
        ? "Editing 1 selected photo"
        : `Editing ${quantityChecked} selected photos`;

    const handleChangeItemInModal = index => {
        clearAllChecked();
        checkItems([uploadsInDropzoneIds[index]]);
    };

    const getCarouselIndex = () => {
        let index = 0;

        const id = currentlyEditingUploadIds && currentlyEditingUploadIds[0];
        uploadsInDropzoneIds.find((uploadId, idx) => {
            if (uploadId === id) {
                index = idx;
                return true;
            }
        });

        return index;
    };

    const conditionalModalProps = isModalCarousel && {
        currentItemIndex: isModalCarousel && getCarouselIndex(),
        carouselLength: uploadsInDropzoneIds && uploadsInDropzoneIds.length - 1
    };

    if (!editModalIsOpen) return null;

    return (
        <AddTagsProvider>
            <EditModal
                open={editModalIsOpen}
                onClose={closeEditModal}
                handleClose={closeEditModal}
                type={modalType}
                heading={modalHeading}
                headingType="h2"
                headingSize="sm"
                size="xl"
                handleChangeItem={handleChangeItemInModal}
                {...conditionalModalProps}
            >
                <Grid desktopSpacing={24} tabletSpacing={24} mobileSpacing={24}>
                    <LeftColGridItem item sm={4} md={4} lg={6}>
                        <ImagesContainer uploads={uploadsCurrentlyEditing} />
                    </LeftColGridItem>
                    <RightColGridItem item sm={8} md={8} lg={6}>
                        <SectionContainer ref={element => rightColRef(element)}>
                            <EditModalContentRightCol
                                hasRightColWidth={hasRightColWidth}
                            />
                        </SectionContainer>
                    </RightColGridItem>
                </Grid>
            </EditModal>
        </AddTagsProvider>
    );
};

Edit.propTypes = {
    uploadsInDropzoneIds: PropTypes.array.isRequired
};

export default Edit;
